import React from "react";
import { Box, getDividerUtilityClass, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import styles from "./Explore_2_2_img.module.css";
const data1 = [
  {
    title1: "先期開發",
    title2: "成本過高",
    value: 21,
    style: styles.Rectangle1,
  },
  {
    title1: "缺乏有效",
    title2: "商業模式",
    value: 18,
    style: styles.Rectangle2,
  },
  {
    title1: "相似產品或",
    title2: "服務競爭者眾",
    value: 14,
    style: styles.Rectangle3,
  },
];
const data2 = [
  {
    title1: "製造成本高",
    title2: "未達經濟規模",
    value: 11,
    style: styles.Rectangle3,
  },
  {
    title1: "市場",
    title2: "景氣不佳",
    value: 9,
    style: styles.Rectangle1,
  },
  {
    title1: "行銷廣告",
    title2: "支出過高",
    value: 8,
    style: styles.Rectangle2,
  },
];
const data3 = [
  {
    title1: "產品服務",
    title2: "不服市場需求",
    value: 7,
    style: styles.Rectangle2,
    color: "#FDD975",
  },
  {
    title1: "法規政策",
    title2: "改變",
    value: 4,
    style: styles.Rectangle3,
    color: "#FDD975",
  },
  {
    title1: "匯率變動",
    value: 1,
    style: styles.Rectangle1,
    color: "#FDD975",
  },
];
function RectangleGroup() {
  return (
    <div className={styles.all}>
      <div className={styles.box}>
        {data1.map((entry, index) => (
          <div className={entry.style}>
            <Typography variant="h4">{entry.value}%</Typography>
            {entry.title1}
            <br />
            {entry.title2}
          </div>
        ))}
      </div>
      <div className={styles.box}>
        {data2.map((entry, index) => (
          <div className={entry.style}>
            <Typography variant="h4">{entry.value}%</Typography>
            {entry.title1}
            <br />
            {entry.title2}
          </div>
        ))}
      </div>
      <div className={styles.box}>
        {data3.map((entry, index) => (
          <div className={entry.style}>
            <Typography variant="h4">{entry.value}%</Typography>
            {entry.title1}
            <br />
            {entry.title2}
          </div>
        ))}
      </div>
    </div>
  );
}

export default RectangleGroup;
